import styled from 'styled-components';
import {JColors} from 'themes/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const SearchContainer = styled.div`
  margin: 0 0 5px;
`;
export const Inner = styled.div``;
export const List = styled.div``;
export const Item = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 7.5px 0 7.5px 20px;
  &:after {
    content: '';
    width: 1px;
    height: 100%;
    display: block;
    position: absolute;
    top: 20px;
    left: 4px;
    bottom: 0;
    background-color: ${JColors.veryLightPink};
  }
  &:nth-last-child(1) {
    &:after {
      display: none;
    }
  }
`;
export const Text = styled.div`
  flex: 1;
  font-family: 'AvenirNext';
  font-size: 12px;
  color: #4a4a4a;
`;
export const Circle = styled.div`
  width: 9px;
  height: 9px;
  display: inline-block;
  background-color: #96979a;
  border-radius: 50%;
  position: absolute;
  top: 12px;
  left: 0;
  margin: auto;
  z-index: 1;
`;
export const Date = styled.div`
  font-family: 'AvenirNext';
  font-size: 12px;
  color: #96979a;
`;
export const RemarkText = styled.div`
  font-family: 'AvenirNext-Italic';
  font-size: 12px;
  color: #4a4a4a;
`;

export default {
  status: {
    STARTED: '#96979a',
    CREATED: JColors.veryLightPink,
    ASSIGNED: JColors.veryLightPink,
    ROUTED: JColors.maize,
    PICKUP_READY: JColors.maize,
    DROPOFF_READY: JColors.maize,
    PICKUP_SUCCEEDED: JColors.periwinkle,
    PICKUPED: JColors.periwinkle,
    SUCCESSED: JColors.darkPastelGreen,
    DROPOFF_SUCCEEDED: JColors.darkPastelGreen,
    SUCCEEDED: JColors.darkPastelGreen,
    RECEIVED_OK: JColors.bluish,
    DROPOFF_FAILED: '#c44',
    PICKUP_FAILED: '#c44',
    FAILED: '#c44',
  },
  strong: {
    fontFamily: 'AvenirNext-Bold',
  },
  coordinatesWrap: {
    marginRight: '5px',
    marginLeft: '5px',
  },
  updateStopWrap: {
    display: 'flex',
    flexDirection: 'row',
  },
};
